__webpack_require__.p = "/Poke-Dict.io/";